// Text-based BoneDry label styled to match the bone-shaped product logos.
// Used for BoneDry variants that don't have a dedicated logo image.
export default function BoneDryLabel({ variant, size = "md" }) {
  const scale = size === "lg" ? { tag: "text-[11px]", name: "text-[30px]", sub: "text-[8px]" } : { tag: "text-[9px]", name: "text-[22px]", sub: "text-[7px]" };
  return (
    <div className="flex flex-col items-center justify-center leading-none select-none">
      <span
        className={`${scale.tag} font-heading font-semibold uppercase tracking-[0.18em] text-white bg-[#1c60a9] px-2 py-0.5 mb-1`}
      >
        {variant}
      </span>
      <span
        className={`${scale.name} font-heading font-bold uppercase tracking-tight text-[#5b6470]`}
        style={{ fontFamily: "Oswald, sans-serif" }}
      >
        BoneDry
      </span>
      <span className={`${scale.sub} uppercase tracking-[0.22em] text-[#9aa2ad] mt-0.5`}>
        Premium Drying Agent
      </span>
    </div>
  );
}
